import React, { useEffect, useState } from "react";
import { Download } from "lucide-react";
import { Button } from "../ui/button";
import { toast } from "sonner";
import { api } from "../../lib/api";

export function OrderAssets({ orderId }) {
  const [assets, setAssets] = useState([]);
  useEffect(() => { api.get(`/admin/orders/${orderId}/assets`).then((r) => setAssets(r.data)).catch((e) => console.error("Could not load order files", e)); }, [orderId]);
  const download = async (a) => {
    try {
      const { data } = await api.get(`/admin/orders/${orderId}/assets/${a.asset_id}`, { responseType: "blob" });
      const url = URL.createObjectURL(data);
      const link = document.createElement("a");
      link.href = url; link.download = a.name; link.click();
      setTimeout(() => URL.revokeObjectURL(url), 1000);
    } catch { toast.error("Download failed"); }
  };
  if (!assets.length) return null;
  return (
    <div className="mt-3" data-testid={`order-assets-${orderId}`}>
      <div className="uppercase text-[10px] tracking-[0.25em] text-[color:var(--text-muted)] mb-1">Original uploaded files</div>
      <ul className="space-y-1">
        {assets.map((a) => (
          <li key={a.asset_id} className="flex items-center justify-between gap-2 text-xs rounded border hairline bg-white px-3 py-2">
            <span className="truncate" data-testid={`asset-name-${a.asset_id}`}>{a.name} · {(a.size / 1024).toFixed(0)} KB</span>
            <Button data-testid={`asset-download-${a.asset_id}`} size="sm" variant="outline" className="rounded-full h-7 shrink-0" onClick={() => download(a)}>
              <Download size={12} className="mr-1"/>Download
            </Button>
          </li>
        ))}
      </ul>
    </div>
  );
}
